import { combineReducers } from 'redux';
import AgentReducer from './agents';
import ProcessReducer from './process';
import BotReducer from './bots';
import SocketReducer from './socket';
import LoginReducer from './login';
import UserReducer from './user';
import { loginActionTypes } from '../actionTypes';
import { socket } from '../../utils/service';
import { Redirect } from 'react-router-dom';
import DownloadReducer from './download';
import CompanyReducer from './company';
import TokenReducer from './token';
import AccountReducer from './account';
import dashboardReducer from './dashboard';
import GroupsReducer from './groups';
import bookDemoReducer from './bookDemo';
import UnsavedFormChangesReducer from './unsavedchanges';
import emailConfigurationReducer from './emailConfiguration';
import queueReducer from './queue';
import CompanyLicenseReducer from './companyLicense';
import priceDetailsReducer from './priceDetails';
import conversionRateReducer from './conversionRate';

const appReducer = combineReducers({
  agents: AgentReducer,
  bots: BotReducer,
  socket: SocketReducer,
  login: LoginReducer,
  user: UserReducer,
  process: ProcessReducer,
  setup: DownloadReducer,
  company: CompanyReducer,
  token: TokenReducer,
  account: AccountReducer,
  dashboard: dashboardReducer,
  groups: GroupsReducer,
  bookDemo: bookDemoReducer,
  unsavedFormChanges: UnsavedFormChangesReducer,
  emailConfiguration: emailConfigurationReducer,
  queueMessages: queueReducer,
  licenseData: CompanyLicenseReducer,
  priceDetails: priceDetailsReducer,
  rateConversion: conversionRateReducer,
});

const rootReducer = (state, action) => {
  if (action.type === loginActionTypes.LOGOUT) {
    localStorage.clear();
    socket.disconnect();
  }
  return appReducer(state, action);
};

export default rootReducer;
